import MainLayout from '@/layouts/main/MainLayout.vue'
import EmptyLayout from '@/layouts/empty/EmptyLayout.vue'
import cookieBar from "@/components/CookieBar/cookieBar.vue"
import facebookLogin from 'facebook-login-vuejs';
import { mapActions } from "vuex";
import Toasts from "@/components/__new_ui_kit/Toasts/Toasts";

export default {
    computed: {
        layout() {
            return (this.$route.meta.layout || 'empty') + '-layout'
        }
    },
    methods: {
        ...mapActions(['updateWidth']),
        screenWidth () {
            this.width = window.innerWidth
            this.updateWidth(this.width)
        }
    },
    components: {
        MainLayout, EmptyLayout, facebookLogin, cookieBar, Toasts
    },
    updated () {
        document.body.classList.remove('no-scroll');
        document.body.classList.remove('no-scroll-login');
    },
    created() {
        this.screenWidth()
        window.addEventListener('resize', this.screenWidth)
    },
    mounted() {
      let iconsScript = document.createElement('script');
      iconsScript.setAttribute('src', "https://kit.fontawesome.com/756e2e6e68.js");
      iconsScript.setAttribute('data-auto-replace-svg', 'nest');
      iconsScript.setAttribute('crossorigin', 'anonymous');
      document.head.appendChild(iconsScript)
    }
}
